
import { defineComponent, Ref, ref, reactive, ComputedRef, computed, onMounted } from 'vue'
import UploadBank from './component/uploadbank/index.vue'
import { useRouter, useRoute } from 'vue-router'

import {AccountInfoParamsType} from '../data.d'
import {RechargeResType,TableListQueryParams, PaginationConfig, RechargeSearch} from './data'
import {UserInfoParams} from '@/services/data.d'

import { useStore } from 'vuex'
import {StateType as AccountInfoStateType} from '../store'
import {StateType as RechargeStateType} from './store'

import {StateType as UserStatusStateType} from '@/store/userstatus'

import { message, Form } from 'ant-design-vue'
import { validateInfos } from 'ant-design-vue/lib/form/useForm'
const useForm = Form.useForm
import useI18nAntdFormVaildateInfos from '@/composables/useI18nAntdFormVaildateInfos'
import dayjs from 'dayjs'

import {
    LoadingOutlined,
    ExclamationCircleOutlined
} from '@ant-design/icons-vue'

import downloadfile from '@/utils/download'

import {copyContent} from '@/utils/copy'
import { twoFloat } from "@/utils/number"

interface paginationDir {
    pageNo: number;
    pageSize: number;
}

interface RechargeSetupData {
    testimg: any;
    columns: Ref<any[]>;
    list: ComputedRef<RechargeResType[]>;
    pagination: ComputedRef<PaginationConfig>;
    validateInfos: ComputedRef<validateInfos>;
    modelRef: RechargeSearch;
    loading: Ref<boolean>;
    visible: Ref<boolean>;
    email: Ref<string>;
    accountinfo: Ref<any>;
    typeStr: Ref<string>;
    infoData: Ref<any>;
    userMsg: any;
    isNum: Ref<any>;
    isT: Ref<boolean>;
    handleShowModal: (e: MouseEvent) => void;
    handleDownload: (e: MouseEvent) => void;
    handleCopy: (type: string) => void;
    handleTableChange: (pagination: PaginationConfig) => void;
    handleSearch: (e: MouseEvent) => void;
    changeTxt: (t: string | number, type: string) => string;
    handleShow: (type: string,record: any) => void;
    getFormData: (type: string) => void;
    twoNumber: (val: number) => number;
    handleGotoCheck: (e: MouseEvent) => void;
    showTxt: (t: string) => string;
}

export default defineComponent({
    name: 'Recharge',
    components: {
        UploadBank,
        LoadingOutlined,
        ExclamationCircleOutlined
    },
    setup():RechargeSetupData {
        const testimg = require('@/assets/images/avtest.png')
        const router = useRouter()
        const route = useRoute()
        const store = useStore<{
            accountquery:AccountInfoStateType,
            rechargequery:RechargeStateType,
            userstatus: UserStatusStateType
        }>()
        const visible = ref<boolean>(false)
        const userMsg = JSON.parse(String(localStorage.getItem('userMsg'))) || {}
        const email = ref<string>(userMsg?.email ?? '')
        const accountinfo = ref<any>({})
        const loading = ref<boolean>(false)
        const searchflag = ref<boolean>(false)
        const searchData = reactive<any>({})
        const typeStr = ref<string>('')
        const infoData = ref<any>({})
        const pageNum = reactive<paginationDir>({pageNo:1,pageSize:10})
        const isNum = ref<any>()
        const isT = ref<boolean>(false)
        const columns = ref<any[]>([])

        //账号编码获取账户信息
        const getAccountInfo = async(params:AccountInfoParamsType) => {
            try {
                const res:boolean = await store.dispatch('accountquery/getAccountByUserCodeFn', params)
                if(res === true){
                    accountinfo.value = store.state.accountquery.accountinfo
                    console.log('accountinfo.value',accountinfo.value)
                    const params = {userCode: userMsg.userCode,...pageNum}
                    getRechargeList(params)
                }
            } catch (error) {
                message.warning()
            }
        }

        const list = computed<RechargeResType[]>(() => store.state.rechargequery.tableData.rechargelist)
        const pagination = computed<PaginationConfig>(() => store.state.rechargequery.tableData.pagination)


        //获取充值列表
        const getRechargeList = async(params:TableListQueryParams) => {
            loading.value = true
            try {
                const res:boolean = await store.dispatch('rechargequery/getRechargeFlowPageList',params)
                if(res===true){
                    isT.value = true
                    if(accountinfo.value.accountType==1){
                        columns.value = [
                            {title:'凭证上传时间', dataIndex:'createdAt', ellipsis: true, width:170},
                            {title:'充值金额', dataIndex:'rechargeAmount', ellipsis: true},
                            {title:'到账金额', dataIndex:'receivedAmount', ellipsis: true},
                            {title:'手续费', dataIndex:'serviceCharge', ellipsis: true},
                            {title:'账户总额', dataIndex: 'cashTotal', ellipsis: true},
                            {title:'冻结金额', dataIndex: 'cashFrozen', ellipsis: true},
                            {title:'可用余额', dataIndex:'cashAvailable', ellipsis: true},
                            {title:'充值币种', dataIndex:'currency', ellipsis: true},
                            {title:'充值完成时间', dataIndex:'arrivalTime', ellipsis: true, width:170},
                            {title:'充值方式', dataIndex:'receivedType', ellipsis: true},
                            {title:'充值状态', dataIndex:'status', ellipsis: true},
                            {title:'汇款时间', dataIndex:'remittanceTime', ellipsis: true, width:170},
                            {title:'付款方名称', dataIndex:'paymentAccount', ellipsis: true},
                            {title:'付款银行名称', dataIndex:'paymentAccountBank', ellipsis: true},
                            {title:'付款银行账号', dataIndex:'paymentAccountNo', ellipsis: true},
                        ]
                    }else{
                        columns.value = [
                            {title:'凭证上传时间', dataIndex:'createdAt', ellipsis: true, width:170},
                            {title:'充值金额', dataIndex:'rechargeAmount', ellipsis: true},
                            {title:'到账金额', dataIndex:'receivedAmount', ellipsis: true},
                            {title:'手续费', dataIndex:'serviceCharge', ellipsis: true},
                            {title:'现金余额', dataIndex:'cashAvailable', ellipsis: true},
                            {title:'可用额度', dataIndex:'creditAvailable', ellipsis: true},
                            {title:'充值币种', dataIndex:'currency', ellipsis: true},
                            {title:'充值完成时间', dataIndex:'arrivalTime', ellipsis: true, width:170},
                            {title:'充值方式', dataIndex:'receivedType', ellipsis: true},
                            {title:'充值状态', dataIndex:'status', ellipsis: true},
                            {title:'汇款时间', dataIndex:'remittanceTime', ellipsis: true, width:170},
                            {title:'付款方名称', dataIndex:'paymentAccount', ellipsis: true},
                            {title:'付款银行名称', dataIndex:'paymentAccountBank', ellipsis: true},
                            {title:'付款银行账号', dataIndex:'paymentAccountNo', ellipsis: true},
                        ]
                    }
                }
            } catch (error) {
                message.warning()
            }
            loading.value = false
        }

        //查询
        const modelRef = reactive<RechargeSearch>({time: []})
        const rulesRef = reactive({time: []})
        const {validate, validateInfos } = useForm(modelRef, rulesRef)
        const validateInfosNew = useI18nAntdFormVaildateInfos(validateInfos)
        const handleSearch = async(e: MouseEvent) => {
            e.preventDefault()
            const fieldsValue = await validate<RechargeSearch>()
            const st = (fieldsValue.time&&(fieldsValue.time as []).length!=0)&&dayjs(fieldsValue.time[0]).format('YYYY-MM-DD 00:00:00') || ''
            const et = (fieldsValue.time&&(fieldsValue.time as []).length!=0)&&dayjs(fieldsValue.time[1]).format('YYYY-MM-DD 23:59:59') || ''
            searchData.value = {
                userCode: userMsg?.userCode,
                rechargeStartTime: st,
                rechargeEndTime: et
            }
            pageNum.pageNo = 1
            pageNum.pageSize = 10
            searchflag.value = true
            const params = {...pageNum, ...searchData.value}
            getRechargeList(params)
        }

        //分页
        const handleTableChange = (pagination:PaginationConfig) => {
            pageNum.pageNo = pagination.current
            pageNum.pageSize = pagination.pageSize
            const params = searchflag.value ? {
                ...searchData.value,
                ...pageNum,
            } : {userCode: userMsg?.userCode, ...pageNum}
            getRechargeList(params)
        }

        //显示弹框
        const handleShowModal = (e: MouseEvent) => {
            e.preventDefault()
            getuserstatus({userCode:userMsg?.userCode})
        }


        //点击充值状态查看
        const handleShow = (type: string, record:any) => {
            typeStr.value = type
            infoData.value = record
            visible.value = true
        }

        //导出
        const handleDownload = async (e: MouseEvent) => {
            const fieldsValue = await validate<RechargeSearch>()
            const st = (fieldsValue.time&&(fieldsValue.time as []).length!=0)&&dayjs(fieldsValue.time[0]).format('YYYY-MM-DD 00:00:00') || ''
            const et = (fieldsValue.time&&(fieldsValue.time as []).length!=0)&&dayjs(fieldsValue.time[1]).format('YYYY-MM-DD 23:59:59') || ''
            const params = {
                userCode: userMsg?.userCode,
                rechargeStartTime: st,
                rechargeEndTime: et,
                accountType: accountinfo.value.accountType
            }
            try {
                downloadfile({
                    params,
                    url: '/seller/v1/accountRechargeFlow/accountRechargeFlowDownload',
                    meth: 'post',
                    type: 'text/plain',
                    filename: `账户充值记录_${new Date().getTime()}.xlsx`
                })
            } catch (error) {
                message.warning('error')
            }
        }

        //点击复制
        const handleCopy = (type?: string) => {
            const cont1 = '苍鸾（广州）信息技术有限公司'
            const cont2 = '中国工商银行股份有限公司深圳桥头支行'
            const cont3 = '4000 1157 0910 0393 121'
            if(type=='act'){copyContent(cont1)}
            if(type=='bank'){copyContent(cont2)}
            if(type=='num'){copyContent(cont3)}
        }


        //显示状态转换
        const changeTxt = (t:string | number, type: string) => {
            const tObjc = {1: 'CNY'}
            const tObjs = {1: '待审核',2: '审核通过',3: '审核驳回'}
            const cycleObj = {1:'一周',2:'两周',3:'三周',10:'一月'}
            const def = { def: t }
            switch(type){
                case 'cur':
                    return tObjc[t] || def['def']
                case 'status':
                    return tObjs[t] || def['def']
                case 'cycle':
                    return cycleObj[t] || def['def']
                default:
                    return def['def']
            }
        }

        //显示失败原因
        const showTxt = (t: string) => {
            if(t!=null){
                const str = t&&JSON.parse(t) || {}
                const strlist = Object.keys(str).map((item:any) => str[item]) || []
                let dt = strlist.map((i:any) => {
                    if(i.includes(':')){
                        return i.split(':')[1]
                    }else{
                        return i
                    }
                }).join('，')
                return dt
            }else{
                return t
            }
        }

        //子组件返回操作
        const getFormData = (type: string) => {
            console.log('type', type);
            if(type == 'updateY'){
                const params = {userCode: userMsg?.userCode}
                const paramsT = {
                    ...pageNum,
                    ...params
                }
                getAccountInfo(params)
                getRechargeList(paramsT)
                typeStr.value = ''
            }
            visible.value = false
        }

        //检查用户状态
        const getuserstatus = async(params:UserInfoParams) => {
            try {
                const res: boolean = await store.dispatch('userstatus/checkAccountStatusFn', params)
                if(res === true){
                    const info:any = store.state.userstatus.accinfo
                    visible.value = false
                    if(info.body){
                        typeStr.value = 'add'
                        infoData.value = {}
                        visible.value = true
                    }else{
                        typeStr.value = 'msg'
                        visible.value = true
                        isNum.value = info.msg
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }
        //跳转至验证页面
        const handleGotoCheck = (e: MouseEvent) => {
            visible.value = false
            router.replace('/personal/account')
        }

        //保留两位小数
        const twoNumber = (val: string | number) => {
            return twoFloat(val);
        }

        //初始化
        const init = () => {
            if(route.query.hasOwnProperty('pop')&&route.query?.pop){
                getuserstatus({userCode:userMsg?.userCode})
            }
            const params = {userCode: userMsg?.userCode}
            getAccountInfo(params)
        }

        onMounted(()=>{
            init()
        })

        return {
            testimg,
            columns,
            list,
            pagination,
            loading,
            visible,
            modelRef,
            validateInfos: validateInfosNew,
            email,
            accountinfo,
            typeStr,
            infoData,
            userMsg,
            isNum,
            isT,
            handleShowModal,
            handleDownload,
            handleCopy,
            handleTableChange,
            handleSearch,
            changeTxt,
            handleShow,
            getFormData,
            twoNumber,
            handleGotoCheck,
            showTxt
        }
    }
})
